import { useAutoneTranslation } from '@autone/translations';
import { useMemo } from 'react';

import { Input } from '../../../../atoms';
import { useAdvancedFiltersContext } from '../AdvancedFilters.context';

interface AdvancedFiltersValueInputProps {
  rowId: string;
}

export const AdvancedFiltersValueInput = ({
  rowId,
}: AdvancedFiltersValueInputProps) => {
  const { common } = useAutoneTranslation();
  const { state, dispatch, config } = useAdvancedFiltersContext();

  const { field, operator, value } = state.conditions[rowId];
  const { fieldConfigs } = config;
  const RenderInputComponent = useMemo(() => {
    if (!field) {
      return null;
    }

    const fieldConfig = fieldConfigs[field];
    return fieldConfig.renderInput;
  }, [field, fieldConfigs]);

  const isDisabled = !field || !RenderInputComponent;

  const handleUpdateValue = (value: unknown) => {
    dispatch({
      type: 'PATCH_CONDITION',
      payload: {
        rowId,
        condition: {
          value,
        },
      },
    });
  };

  if (isDisabled) {
    return (
      <Input
        id="advanced-filter-input"
        variant={'default'}
        disabled={isDisabled}
        placeholder={common('advanced-filters.value')}
        className="rounded-l-none rounded-r-sm border-l-0"
      />
    );
  } else {
    return (
      <RenderInputComponent
        value={value}
        onValueChange={handleUpdateValue}
        operator={operator}
      />
    );
  }
};
